import { render, staticRenderFns } from "./Dictation.vue?vue&type=template&id=7b165601&scoped=true"
import script from "./Dictation.vue?vue&type=script&lang=js"
export * from "./Dictation.vue?vue&type=script&lang=js"
import style0 from "./Dictation.vue?vue&type=style&index=0&id=7b165601&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b165601",
  null
  
)

export default component.exports